<template>
  <span
    :class="componentClass"
    :style="componentStyle"
    v-bind="rootAttrs"
  >
    <span
      v-if="explanation"
      class="sr-only"
    >
      {{ explanation }}
    </span>
    {{ label }}
  </span>
</template>

<script>
  export default {
    name: 'Tag',

    inheritAttrs: false,

    props: {
      background: {
        type: String,
        default: null
      },
      color: {
        type: String,
        default: null
      },
      customStyle: {
        type: Object,
        default: () => {}
      },
      explanation: {
        type: String,
        default: null
      },
      isInteractive: {
        type: Boolean,
        default: false
      },
      isRounded: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: null
      },
      position: {
        type: String,
        default: null
      },
      size: {
        type: String,
        default: null
      },
      theme: {
        type: String,
        default: null
      }
    },

    computed: {
      // Vue 2 kept handlers in `$listeners`, so `v-on="isInteractive ? $listeners : {}"`
      // passed them through only for an interactive tag. Vue 3 folds handlers INTO
      // `$attrs`, and the migration renamed the binding in place -- which bound every
      // plain attribute as an event (`aria-label` arrived as `onAria-label`, warning on
      // each render) while the gate itself stopped working, because the real handler
      // reached the root through attribute fallthrough whether or not the tag was
      // interactive. Binding the attrs here instead, with handlers dropped when the tag
      // is not interactive, restores what the Vue 2 expression meant.
      rootAttrs() {
        if (this.isInteractive) return this.$attrs

        const attrs = {}

        for (const [name, value] of Object.entries(this.$attrs)) {
          if (!/^on[A-Z]/.test(name)) attrs[name] = value
        }

        return attrs
      },

      componentClass() {
        return [`tag ${this.size} ${this.theme} ${this.position}`, { rounded: this.isRounded }]
      },
      componentStyle() {
        let style = {}

        if (this.background) {
          style['--tag-background'] = this.background
        }

        if (this.color) {
          style['--tag-color'] = this.color
        }

        return {
          ...style,
          ...this.customStyle
        }
      }
    }
  }
</script>
